import { jsPDF } from "jspdf";
import "jspdf-autotable";
import "./Cookie-Regular-normal";
import "./Nunito-normal";
import "./Nunito-italic";
import "./Nunito-bold";
import { _ } from "core-js";

// Definition des options du format
const options = {
  orientation: "p",
  unit: "mm",
  format: "a4"
};

const colors = {
  blue: "#0083ff",
  orange: "#d6204e",

  black: "#1f2937",
  white: "#FAFFFD",
  gray: "#a6a6a6"
};

const HEIGHT = 297;
const WIDTH = 210;
const MARGIN = 10;
const MARGIN_X = 10;
const MARGIN_Y = 10;
var textOffsetX = 10;
var textOffsetY = 10;
let pageNumber = 0;

function contentWidth() {
  return WIDTH - 2 * MARGIN_X;
}

function contentHeight() {
  return HEIGHT - 2 * MARGIN_Y;
}

//Creation of the PDF object
var doc = new jsPDF(options);
setDefaultFont();

export function makeReport(pdfData) {
  pageNumber = 0;
  doc = new jsPDF(options);
  console.log(pdfData);
  console.log(doc.getFontList());
  addHeader();
  doc.setFontSize(24);
  setDefaultFont();
  doc.setTextColor(colors.orange);
  setTextPosition(WIDTH / 2, HEIGHT / 2);
  addTitle("Rapport : " + pdfData.module.name, 32, {
    align: "center",
    maxWidth: WIDTH - 2 * MARGIN
  });

  doc.setTextColor("#333");
  doc.setFontSize(10);
  addText(
    "Ce rapport a été édité le " + new Date().toString("dddd, MMMM ,yyyy"),
    {
      align: "center"
    }
  );

  addSommaire(pdfData.titles);

  doc.addPage();
  addHeader();
  setTextPosition(MARGIN_X, 3 * MARGIN_Y);
  doc.setTextColor(colors.blue);
  addTitle("I- Résumé de la problématique et l'axe d'analyse", 18);
  setTextPosition(2 * MARGIN_X, textOffsetY);
  addTitle("1- Définition du module", 14);

  doc.setTextColor(colors.black);
  addContentText(pdfData.module.description);

  // Adding top margin before second title
  setTextPosition(textOffsetX, MARGIN_Y + textOffsetY);
  doc.setTextColor(colors.blue);
  addTitle("2- Définition et Énoncé de la problématique", 14);
  doc.setTextColor(colors.black);
  addTitle(pdfData.folder.name, 12);
  doc.setTextColor(colors.black);
  addContentText(pdfData.folder.description);

  doc.setTextColor(colors.orange);
  addTitle("Résumé", 12);
  doc.setTextColor(colors.black);
  addContentText(pdfData.folder.resume);
  doc.setTextColor(colors.orange);
  addTitle("Objectif poursuivie", 12);
  doc.setTextColor(colors.black);
  addTitle(pdfData.folder.result, 12);

  // Adding top margin before third
  setTextPosition(textOffsetX, MARGIN_Y + textOffsetY);
  doc.setTextColor(colors.blue);
  addTitle("3- Définition de l’axe d’analyse et énoncé de l’axe d’analyse", 14);
  doc.setTextColor(colors.black);
  addTitle(pdfData.file.name, 12);
  doc.setTextColor(colors.black);
  addContentText(pdfData.file.description);

  doc.addPage();
  addHeader();
  setTextPosition(MARGIN_X, 3 * MARGIN_Y);
  doc.setTextColor(colors.blue);
  addTitle(pdfData.titles[0], 18);

  setTextPosition(textOffsetX + MARGIN_X, textOffsetY);
  doc.autoTable({
    styles: { valign: "middle" },
    head: [["", ...pdfData.identificationLabel]],
    body: _.zip(
      pdfData.actors.map((x, index) => index + 1),
      ...pdfData.identificationKey.map(key => {
        return pdfData.actors.map(x => x[key]);
      })
      /* pdfData.actors.map((x) => x.abbreviation),
      pdfData.actors.map((x) => x.name),
      pdfData.actors.map((x) => x.role) */
    ),
    startY: textOffsetY
  });

  doc.addPage();
  addHeader();
  setTextPosition(MARGIN_X, 3 * MARGIN_Y);
  doc.setTextColor(colors.blue);
  addTitle(pdfData.titles[1], 18);
  setTextPosition(2 * MARGIN_X, textOffsetY);

  /* doc.setTextColor(colors.black);
  addContentText("PPN: Partie Prénante Non Institutionnelle", 10);
  addContentText("PPI: Partie Prénante Institutionnelle", 10);
  addContentText("PF: Partenaire Financier", 10); */
  doc.autoTable({
    head: [pdfData.categoriesLabel],
    body: _.zip(
      pdfData.actors.map(x => x[pdfData.actorKey]),
      ...pdfData.categoriesKey.map(key => {
        return pdfData.actors.map(x => x[key].value);
      })
      /*   pdfData.actors.map((x) => {
        if (x.type.id == 1) return "PPN";
        if (x.type.id == 2) return "PPI";
        if (x.type.id == 3) return "PF";
      }),
      pdfData.actors.map((x) => {
        return x.influence.value;
      }),

      pdfData.actors.map((x) => {
        return x.implication.value;
      }) */
    ),
    startY: textOffsetY
  });

  doc.addPage("a4", "l");
  addHeader("l");
  setTextPosition(MARGIN_X, 3 * MARGIN_Y);
  doc.setTextColor(colors.blue);
  addTitle(pdfData.titles[2], 18);
  setTextPosition(2 * MARGIN_X, textOffsetY);
  doc.addImage(
    pdfData.images[0].data,
    "jpg",
    textOffsetX,
    textOffsetY,
    pdfData.images[0].isRectangle
      ? WIDTH - 0.2 * textOffsetX
      : WIDTH - 3 * textOffsetX,
    pdfData.images[0].isRectangle
      ? WIDTH - 3 * textOffsetX - (WIDTH - 3 * textOffsetX) * 0
      : WIDTH - 3 * textOffsetX
  );
  doc.addImage(
    pdfData.images[0].legend,
    "jpg",
    WIDTH - (pdfData.images[0].isRectangle ? 0 : 2) * textOffsetX + textOffsetX,
    textOffsetY,
    pdfData.images[0].width ??
      contentHeight() - (WIDTH - 2 * textOffsetX) - 2 * textOffsetX,
    pdfData.images[0].height ?? (WIDTH - 2 * textOffsetX) / 2
  );

  if (pdfData.titles[3]) {
    doc.addPage("a4", "l");
    addHeader("l");
    setTextPosition(MARGIN_X, 3 * MARGIN_Y);
    doc.setTextColor(colors.blue);

    addTitle(pdfData.titles[3], 18);

    setTextPosition(2 * MARGIN_X, textOffsetY);
    doc.addImage(
      pdfData.images[1].data,
      "jpg",
      textOffsetX,
      textOffsetY,
      pdfData.images[1].isRectangle
        ? WIDTH - 1 * textOffsetX
        : WIDTH - 3 * textOffsetX,
      pdfData.images[1].isRectangle
        ? WIDTH - 3 * textOffsetX - (WIDTH - 3 * textOffsetX) * 0.25
        : WIDTH - 3 * textOffsetX
    );
    doc.addImage(
      pdfData.images[1].legend,
      "jpg",
      WIDTH - 2 * textOffsetX + textOffsetX,
      textOffsetY,
      pdfData.images[1].width ??
        contentHeight() - (WIDTH - 2 * textOffsetX) - 2 * textOffsetX,
      pdfData.images[1].height ?? (WIDTH - 2 * textOffsetX) / 2
    );
  }

  /*  pdfData.images.forEach((image) => {
    doc.addPage("a4", "p");
    addHeader();
    setTextPosition(MARGIN_X, 3 * MARGIN_Y);
    doc.addImage(
      image.data,
      "jpg",
      textOffsetX,
      textOffsetY,
      WIDTH - 2 * textOffsetX,
      WIDTH - 2 * textOffsetX
    );
    setTextPosition(
      textOffsetX,
      textOffsetY + (WIDTH - 2 * textOffsetX) + MARGIN_Y
    );
    addContentText(image.title);
  }); */

  doc.save(pdfData.file.name + " - Rapport.pdf");
}

function addHeader(orientation = "p") {
  if (pageNumber < 1) {
    pageNumber += 1;
    return;
  }
  doc.setFillColor(colors.blue);
  doc.rect(
    MARGIN_X,
    MARGIN_Y + doc.getLineHeightFactor(),
    orientation == "p" ? contentWidth() : contentHeight(),
    2,
    "F"
  );
  setLogoFont();
  doc.setFontSize(14);
  doc.setTextColor(colors.orange);
  doc.text(
    "Page " + pageNumber++,
    orientation == "p" ? contentWidth() : contentHeight(),
    MARGIN_Y
  );
  doc.text("StratOChange", MARGIN_X, MARGIN_Y);
  doc.setTextColor(colors.black);
}

function addSommaire(titles) {
  doc.addPage();
  addHeader();
  setTextPosition(WIDTH / 2, 3 * MARGIN_Y);
  doc.setTextColor(colors.orange);
  addTitle("SOMMAIRE", 24, { align: "center" });

  setTextPosition(2 * MARGIN_X, textOffsetY + MARGIN_Y);
  doc.setTextColor(colors.blue);
  addTitle("Résumé de la problématique de l'axe d'analyse", 16);
  setTextPosition(textOffsetX + MARGIN_X, textOffsetY);
  addTitle("1-  Définition du module", 14);
  addTitle(
    "2-  Définition de la problématique et énoncé de la problématique",
    14
  );
  addTitle(
    "3-  Définition de l’axe d’analyse et énoncé de l’axe d’analyse",
    14
  );
  setTextPosition(textOffsetX - MARGIN_X, textOffsetY);
  titles.forEach(title => {
    addTitle(title, 16);
  });

  /*  addTitle(
    "III- Classification des acteurs en fonction des trois catégories",
    16
  );
  addTitle("IV- Définition des rélations entre les acteurs", 16);
  addTitle(
    "V-  Visualisation du diagramme de l'analyse du jeu des acteurs",
    16
  ); */
}

function setLogoFont() {
  doc.setFont("Cookie-Regular", "normal");
}

function setDefaultFont() {
  doc.setFont("Nunito", "normal");
}

function setTextPosition(x, y) {
  textOffsetY = y;
  textOffsetX = x;
}
function addTitle(text, fontSize, options) {
  doc.setFontSize(fontSize ?? 16);
  doc.setFont("Nunito", "bold");
  setTextPosition(textOffsetX, textOffsetY);
  addText(text, options);
  textOffsetY += doc.getLineHeightFactor();
}

function addContentText(text, fontSize) {
  doc.setFontSize(fontSize ?? 12);
  setDefaultFont();
  setTextPosition(textOffsetX, textOffsetY);
  addText(text);
}

function addText(text, options) {
  var textWidth = doc.getTextWidth(text);

  var textHeight = (Math.ceil(textWidth / (WIDTH - 2 * MARGIN)) + 1) * 4.5;
  console.log("Text width: ", Math.ceil(textWidth / (WIDTH - 2 * MARGIN)));
  console.log("Text height: ", textHeight);
  doc.text(text, textOffsetX, textOffsetY, {
    ...options,
    maxWidth: WIDTH - 2 * MARGIN
  });

  textOffsetY += textHeight;
  if (textOffsetY > HEIGHT - MARGIN * 3) {
    doc.addPage();
    addHeader();
    setTextPosition(textOffsetX, 3 * MARGIN_Y);
  }
}
